
<template>
    
  <div class="quantcat-intro">
    <div class="image-container">
    <img :src="require('@/assets/quantcat.png')" alt="Quant Cat" class="logo"/>
  </div>
    <p class="intro-text">
      <span class="icon"></span> 
     
      Meet QuantCat, your guide to the complex world of finance and creator of MeowGPT.
      <span class="icon"></span>
    </p>

    <p>
      As the digital whisperer of data, I've always believed that the answers lie within the numbers. And what better way to untangle the web of financial queries than with MeowGPT, our purr-eminent chat companion?
    </p>


    <p class="closing-remark">
      Please note: To ensure the security of your financial data, refrain from entering any personal information in this field.  All of your personal information throughout RiskyPaws is fully protected and is not used in any large language learning models.
    </p>
  </div>
      <div class="page-content">
        <div ref="chatContainer" class="chat-container">
          <div v-for="message in messages" :key="message.id" :class="message.class">
            {{ message.text }}
          </div>
        </div>
      </div>
 
        <div class="speech-input">
          <input v-model="userMessage" @keyup.enter="sendMessage" type="text" placeholder="Enter your question here">
          <button @click="sendMessage">Send</button>
        </div>
  <br><br><br> <br><br><br> <br><br><br> <br><br><br>

  </template>
  
  
  <script>
  export default {
    data() {
      return {
        userMessage: '',
        messages: [],
        nextMessageId: 1
      };
    },
    methods: {
      async sendMessage() {
        this.messages.push({ id: this.nextMessageId++, text: this.userMessage, class: 'speech-left' });
        const response = await fetch("https://farahk.pythonanywhere.com/askStingyCat/?question=" + this.userMessage);
        const data = await response.json();
        this.messages.push({ id: this.nextMessageId++, text: data.reply, class: 'speech-right' });
        this.userMessage = '';
        this.$nextTick(() => {
          const container = this.$refs.chatContainer;
          container.scrollTop = container.scrollHeight;
        });
      },
    },
  };
  </script>
  
  <style scoped>
.header {
  text-align: center;
  padding: 20px;
}

.intro-text {
  font-size: 14px;
  margin-top: 10px;
}

.page-content {
  padding: 15px;
  overflow-y: auto;
  max-height: 500px;
}

.chat-container {
  display: flex;
  flex-direction: column;
}

.speech-left {
  max-width: 70%;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f1f1f1;
  border-radius: 12px;
}

.speech-right {
  align-self: flex-end;
  max-width: 70%;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border-radius: 12px;
}
.image-container {
  text-align: center; /* This centers the image horizontally */
  margin: 0 auto; /* This also helps in centering if the container has a set width */
  padding: 1rem; /* Optional padding around the image */
}

.logo {
  max-width: 100%; /* Ensures the image is responsive and doesn't overflow its container */
  height: auto; /* Maintains the aspect ratio of the image */
  /* Assuming you want the image to be no larger than 520px in width on larger screens */
  width: 520px; 
  display: block; /* To enable proper margin calculation for auto */
  margin: 0 auto; /* This centers the image in the block */
}

@media (max-width: 768px) {
  .logo {
    width: 60%; /* On smaller screens, the image will take up 80% of the container width */
  }
}
.speech-input {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-top: 1px solid #ccc;
}


button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}
input[type="text"] {
  flex: 1;
  padding: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border: 1px solid #ccc;
  width: calc(100% - 20px); /* Adjust based on padding and margin */
  box-sizing: border-box; /* Includes padding and border in element's total width */
}

input[type="text"]:focus {
  /* Prevent resizing by not changing size-related properties */
}
.quantcat-intro {
  background-color: #f3f4f6; /* Light grey background */
  border-left: 4px solid #4A148C; 
  padding: 1rem;
  border-radius: 8px;
  margin: 1rem 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Soft shadow for depth */
}

.intro-text {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.5rem;
}

.intro-text .icon {
  font-size: 1.5rem;
}

.closing-remark {
  font-style: italic;
  color: #555;
}

/* Additional media query for responsiveness */
@media (max-width: 768px) {
  .quantcat-intro {
    padding: 0.5rem;
    border-left-width: 2px;
  }

  .intro-text {
    font-size: 1rem;
  }

  .intro-text .icon {
    font-size: 1.2rem;
  }
}
</style>
  
 